import { Map } from "immutable"

// Url params - currently it is getting from MainView
export default function PageReducer(state = Map(), action) {
  switch (action.type) {
    case "UPDATE_ROUTE":
      return Map({
        // check routes.jsx for possible values
        name: action.pageName, // e.g. booking
        namesPath: action.pageNamesPath, // e.g. `app/booking`
      })

    default:
      return state
  }
}
